var _circle, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 171,
    viewBox: "0 0 103 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1722,
    cy: 82.4742,
    r: 48.8277,
    fill: "url(#paint0_linear_2333_21125)",
    stroke: "#6AA442",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2333_21125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7251 12.75C20.4825 12.75 19.4751 13.7574 19.4751 15V144.577C19.4751 147.476 21.8256 149.827 24.7251 149.827H77.3092C80.2087 149.827 82.5592 147.476 82.5592 144.577V15C82.5592 13.7574 81.5519 12.75 80.3092 12.75H21.7251Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.7247 13.9226V33.8514L82.027 33.6669L82.3089 13.9226C82.3089 13.3321 80.0536 13.0615 78.9259 13H24.2353C20.6268 13 19.7247 13.6151 19.7247 13.9226Z",
    fill: "#DEE0E5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9669 21.9979C37.8382 21.7764 37.6728 21.6572 37.3788 21.6572C37.0847 21.6572 36.809 21.8616 36.809 22.1513C36.809 22.4239 37.1031 22.5431 37.342 22.6454L37.5626 22.7305C38.0037 22.918 38.3712 23.1054 38.3712 23.6165C38.3712 24.1617 37.8934 24.5877 37.3053 24.5877C36.7539 24.5877 36.3496 24.264 36.2577 23.7699L36.6253 23.6676C36.6804 23.9913 36.9377 24.2469 37.3053 24.2469C37.6728 24.2469 38.0037 23.9913 38.0037 23.6336C38.0037 23.2587 37.6912 23.1395 37.3788 23.0032L37.1766 22.918C36.7723 22.7476 36.4415 22.5602 36.4415 22.1172C36.4415 21.6231 36.8826 21.3164 37.3972 21.3164C37.7831 21.3164 38.0955 21.4868 38.2793 21.8105L37.9669 21.9979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0445 23.2575C40.0445 23.496 40.0445 23.7516 40.1915 23.9561C40.3386 24.1435 40.6326 24.2627 40.8716 24.2627C41.1105 24.2627 41.3862 24.1605 41.5332 23.9901C41.717 23.7857 41.6986 23.5131 41.6986 23.2746V21.4004H42.0845V23.3597C42.0845 23.7005 42.0662 23.9731 41.7905 24.2287C41.5516 24.4672 41.2207 24.5865 40.8716 24.5865C40.5591 24.5865 40.2283 24.4672 39.9894 24.2627C39.6953 24.0072 39.6586 23.7175 39.6586 23.3597V21.4004H40.0445V23.2575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3883 21.2656L46.0348 23.8383V21.4019H46.4208V24.6902L43.7743 22.1346V24.5539H43.3883V21.2656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.204 21.7236H48.351C48.7921 21.7236 49.2332 21.7576 49.2332 22.2688C49.2332 22.7118 48.884 22.831 48.4613 22.831H48.204V21.7236ZM48.204 23.1547H48.4797C48.7554 23.1547 49.0494 23.1207 49.2883 22.9503C49.4905 22.7799 49.6191 22.5243 49.6191 22.2688C49.6191 21.9962 49.4905 21.7236 49.2332 21.5532C48.9943 21.3999 48.6818 21.3828 48.3878 21.3828H47.8364V24.5178H48.2224V23.1547H48.204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7016 23.7521L56.8043 21.2305L57.907 23.7521L58.7892 21.4008H59.1935L57.8886 24.7062L56.7859 22.1846L55.6832 24.7062L54.3783 21.4008H54.7826L55.7016 23.7521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0189 21.4004H61.7833V21.7241H60.4049V22.6612H61.7465V22.9849H60.4049V24.2116H61.7833V24.5354H60.0189V21.4004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4403 21.7236H63.5505C64.01 21.7236 64.4143 21.7747 64.4143 22.2858C64.4143 22.7799 63.9916 22.8481 63.5505 22.8481H63.4403V21.7236ZM63.4403 23.1547H63.5322L64.5614 24.5348H65.0208L63.9365 23.1207C64.4511 23.0866 64.7819 22.7458 64.7819 22.2517C64.7819 21.5362 64.1938 21.3828 63.5505 21.3828H63.0543V24.5178H63.4403V23.1547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9666 21.9979C37.838 21.7764 37.6726 21.6572 37.3785 21.6572C37.0845 21.6572 36.8088 21.8616 36.8088 22.1513C36.8088 22.4239 37.1029 22.5431 37.3418 22.6454L37.5623 22.7305C38.0034 22.918 38.371 23.1054 38.371 23.6165C38.371 24.1617 37.8931 24.5877 37.305 24.5877C36.7537 24.5877 36.3493 24.264 36.2574 23.7699L36.625 23.6676C36.6802 23.9913 36.9375 24.2469 37.305 24.2469C37.6726 24.2469 38.0034 23.9913 38.0034 23.6336C38.0034 23.2587 37.691 23.1395 37.3785 23.0032L37.1764 22.918C36.772 22.7476 36.4412 22.5602 36.4412 22.1172C36.4412 21.6231 36.8823 21.3164 37.3969 21.3164C37.7829 21.3164 38.0953 21.4868 38.2791 21.8105L37.9666 21.9979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0443 23.2575C40.0443 23.496 40.0443 23.7516 40.1913 23.9561C40.3383 24.1435 40.6324 24.2627 40.8713 24.2627C41.1102 24.2627 41.3859 24.1605 41.5329 23.9901C41.7167 23.7857 41.6983 23.5131 41.6983 23.2746V21.4004H42.0843V23.3597C42.0843 23.7005 42.0659 23.9731 41.7902 24.2287C41.5513 24.4672 41.2205 24.5865 40.8713 24.5865C40.5589 24.5865 40.2281 24.4672 39.9891 24.2627C39.6951 24.0072 39.6583 23.7175 39.6583 23.3597V21.4004H40.0443V23.2575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2041 21.7236H48.3511C48.7922 21.7236 49.2333 21.7576 49.2333 22.2688C49.2333 22.7118 48.8841 22.831 48.4614 22.831H48.2041V21.7236ZM48.2041 23.1547H48.4798C48.7555 23.1547 49.0495 23.1207 49.2885 22.9503C49.4906 22.7799 49.6193 22.5243 49.6193 22.2688C49.6193 21.9962 49.4906 21.7236 49.2333 21.5532C48.9944 21.3999 48.682 21.3828 48.3879 21.3828H47.8365V24.5178H48.2225V23.1547H48.2041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7013 23.7521L56.804 21.2305L57.9067 23.7521L58.7889 21.4008H59.1932L57.8884 24.7062L56.7856 22.1846L55.6829 24.7062L54.3781 21.4008H54.7824L55.7013 23.7521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0187 21.4004H61.783V21.7241H60.4046V22.6612H61.7463V22.9849H60.4046V24.2116H61.783V24.5354H60.0187V21.4004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.44 21.7236H63.5503C64.0098 21.7236 64.4141 21.7747 64.4141 22.2858C64.4141 22.7799 63.9914 22.8481 63.5503 22.8481H63.44V21.7236ZM63.44 23.1547H63.5319L64.5611 24.5348H65.0206L63.9362 23.1207C64.4508 23.0866 64.7817 22.7458 64.7817 22.2517C64.7817 21.5362 64.1935 21.3828 63.5503 21.3828H63.0541V24.5178H63.44V23.1547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8818 22.9671C53.8818 23.8871 53.0915 24.5857 52.0991 24.5857C51.125 24.5857 50.3531 23.8531 50.3531 22.9841C50.3531 22.0982 51.125 21.3655 52.0991 21.3655C53.0915 21.3485 53.8818 22.0471 53.8818 22.9671ZM50.7391 22.9671C50.7391 23.6316 51.3088 24.2279 52.0807 24.2279C52.871 24.2279 53.4775 23.6827 53.4775 22.9671C53.4775 22.2345 52.871 21.6893 52.0807 21.6893C51.3088 21.7063 50.7391 22.2856 50.7391 22.9671Z",
    fill: "black"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1291 56.2661H47.8082C46.9363 56.2661 46.2251 55.6622 46.2251 54.922V43.5356C46.2251 42.7953 46.9363 42.1914 47.8082 42.1914H54.1291C55.0009 42.1914 55.7122 42.7953 55.7122 43.5356V54.922C55.7122 55.6622 55.0009 56.2661 54.1291 56.2661ZM47.8082 42.3765C47.0625 42.3765 46.4545 42.8927 46.4545 43.5258V54.9122C46.4545 55.5453 47.0625 56.0616 47.8082 56.0616H54.1291C54.8747 56.0616 55.4827 55.5453 55.4827 54.9122V43.5356C55.4827 42.9024 54.8747 42.3862 54.1291 42.3862H47.8082V42.3765Z",
    fill: "#808080"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2333_21125",
    x: 7.2251,
    y: 0.5,
    width: 95.5841,
    height: 169.576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.59402 0 0 0 0 0.613197 0 0 0 0 0.641963 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2333_21125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2333_21125",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2333_21125",
    x1: 50.1722,
    y1: 132.176,
    x2: 50.1722,
    y2: 36.8134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AA442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBB71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollIcon);
export default __webpack_public_path__ + "static/media/enroll-icon.da741fccdadf4e077ecc9242bc161290.svg";
export { ForwardRef as ReactComponent };